<div class="modal-header">
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
  <h4 class="modal-title">Install artifacts</h4>
</div>

<div class="form-group modal-body">
  <h1>Packages to install</h1>
  @for (package of nugetPackages; track package) {
    <div>
      <br>
        <app-collapsible-panel [collapsed]="nugetPackages.length > 1">
          <div title>
            <img class="package-icon" [src]="getNugetPackageIconUrl(package.NugetPackage.NugetFeedId, package.NugetPackage.NugetPackageId)" height="40px" width="40px" />
            <div class="package-title">{{getNugetPackageName(package.NugetPackage.NugetFeedId, package.NugetPackage.NugetPackageId)}}</div>
          </div>
          @if (package.XmlArtifacts.length > 0 || package.AssemblyArtifacts.length > 0) {
            <div>
              @if (package.XmlArtifacts.length > 0) {
                <div>
                  <h2>XML Artifacts</h2>
                  <app-xml-artifact-grid [artifacts]="package.XmlArtifacts"></app-xml-artifact-grid>
                </div>
              }
              @if (package.AssemblyArtifacts.length > 0) {
                <div>
                  @if (package.XmlArtifacts.length > 0) {
                    <hr>
                    }
                    <h2>Assembly Artifacts</h2>
                    <app-assembly-artifact-grid [artifacts]="package.AssemblyArtifacts"></app-assembly-artifact-grid>
                  </div>
                }
              </div>
            } @else {
              <div>
                <br>
                  <p>This package contains no Link artifacts</p>
                </div>
              }
            </app-collapsible-panel>
          </div>
        }
      </div>

      <div class="modal-footer">
        <div class="text-center">
          <button type="button" class="btn btn-primary mw-12" (click)="ok()">Save</button>
          <button class="btn btn-primary" (click)="cancel()">Cancel</button>
        </div>
      </div>

